import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpService } from 'src/service/http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router, private httpService: HttpService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const data = localStorage.getItem('userData');
    let isAuth = (data && data !== null) ? true : false;

    /* With Ip Restriction Code */
    this.httpService.IPWhitelist({
      "_ip": localStorage.getItem('IP'),
      "_userId": localStorage.getItem("uuid")
    }
    ).subscribe(address => {
      if (isAuth && address && address.responseCode != 0 && localStorage.getItem('roleName') != 'SUPER ADMIN') {
        this.router.navigate(['/access-restriction-page'])
        //return true;
      }
    }, err => {

    })
    /* Without Ip Restriction */

    // if (!isAuth) {
    //     this.router.navigate(['/sign-in']);

    // }


    return isAuth;
  }

  checkIdStatus() {


    if (localStorage.getItem('roleName') === 'SUPER ADMIN') {



    }
    /*else if(localStorage.getItem('roleName') === 'LAB ANALYST'){

      this.httpService.checkIpAddress().subscribe(data => {

        const iPAddress = this.httpService.restrictedIpAddress;

    

          if (data.ip === iPAddress[0] || data.ip === iPAddress[1] || data.ip === iPAddress[2] || data.ip === iPAddress[3] || data.ip === iPAddress[4]|| data.ip === iPAddress[5]) {


          }

          else {

            this.router.navigate(['access-restriction-page'])

          }

        

      }, err => {

        this.router.navigate(['access-restriction-page'])

      })  

    }*/

    else {

      /*this.httpService.checkIpAddress().subscribe(data => {

        const iPAddress = this.httpService.restrictedIpAddress;

        for (let i = 0; i < iPAddress.length; i++) {

          if (data.ip === iPAddress[0] || data.ip === iPAddress[1] || data.ip === iPAddress[2] || data.ip === iPAddress[3] || data.ip === iPAddress[4]) {


          }

          else {

            this.router.navigate(['access-restriction-page'])

          }

        }

      }, err => {

        this.router.navigate(['access-restriction-page'])

      })*/

    }





  }
}



// this.router.navigate(['/access-restriction']);
